/**
 * Task NN: 投诉与建议 / Feedback (shop page, store app, Senvia 助手 link) + Platform admin → 投诉与建议 inbox.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["nn.nav","Feedback","投诉与建议"],
  ["nn.title","Complaints & suggestions","投诉与建议"],
  ["nn.sub","Tell the Senvia team what went wrong or what you would like. We answer here and by e-mail.","告诉 Senvia 团队哪里出了问题、哪里不好用，或者你希望增加什么。我们会在这里和通过邮件回复。"],
  ["nn.new","New ticket","提交反馈"],
  ["nn.empty","No tickets yet. Problems, ideas or complaints — send them here.","还没有反馈。遇到问题、有建议或想投诉，都可以在这里提交。"],
  ["nn.type","Type","类型"],
  ["nn.type.complaint","Complaint","投诉"],
  ["nn.type.suggestion","Suggestion","建议"],
  ["nn.type.bug","Bug report","问题回报"],
  ["nn.cat","Category","分类"],
  ["nn.cat.pos","Checkout (POS)","收银"],
  ["nn.cat.booking","Bookings","预约"],
  ["nn.cat.membership","Membership & packages","会员/配套"],
  ["nn.cat.payroll","Payroll","工资"],
  ["nn.cat.website","Website & online shop","官网/网店"],
  ["nn.cat.app","App","App"],
  ["nn.cat.billing","Billing & payment","账单/付款"],
  ["nn.cat.other","Other","其他"],
  ["nn.st.submitted","Submitted","已提交"],
  ["nn.st.in_progress","In progress","处理中"],
  ["nn.st.replied","Replied","已回复"],
  ["nn.st.resolved","Resolved","已解决"],
  ["nn.st.closed","Closed","已关闭"],
  ["nn.pr.low","Low","低"],
  ["nn.pr.normal","Medium","中"],
  ["nn.pr.high","High","高"],
  ["nn.pr.urgent","Urgent","紧急"],
  ["nn.f.title","Title","标题"],
  ["nn.f.titlePh","e.g. The receipt prints twice","例如：收据打印了两次"],
  ["nn.f.desc","Description","详细说明"],
  ["nn.f.descPh","What happened, what you expected, how to repeat it …","发生了什么、你期望的结果、怎样可以重现……"],
  ["nn.f.images","Screenshots (optional, up to {n})","截图（可选，最多 {n} 张）"],
  ["nn.f.addImage","Add image","添加图片"],
  ["nn.f.removeImage","Remove image","移除图片"],
  ["nn.f.imagesHint","Images are compressed and count towards your shop's storage.","图片会自动压缩，并计入店铺的存储空间。"],
  ["nn.f.context","Sent with your ticket","随反馈一起发送"],
  ["nn.f.contextHint","This helps us find the problem faster.","这些信息能帮我们更快找到问题。"],
  ["nn.ctx.page","Page","页面"],
  ["nn.ctx.app","App version","App 版本"],
  ["nn.ctx.device","Device","设备"],
  ["nn.ctx.branch","Branch","分店"],
  ["nn.ctx.bundle","Web bundle","网页包版本"],
  ["nn.ctx.role","Role","角色"],
  ["nn.ctx.client","Client","客户端"],
  ["nn.ctx.phone","Phone","电话"],
  ["nn.p.minutes","{n} min","{n} 分钟"],
  ["nn.send","Send","发送"],
  ["nn.sending","Sending …","发送中……"],
  ["nn.sent","Thanks — the Senvia team received ticket {ref}.","谢谢！Senvia 团队已收到反馈 {ref}。"],
  ["nn.cancel","Cancel","取消"],
  ["nn.back","All tickets","全部反馈"],
  ["nn.thread","Conversation","对话"],
  ["nn.senvia","Senvia team","Senvia 团队"],
  ["nn.replyPh","Write a message …","输入消息……"],
  ["nn.sendMsg","Send message","发送消息"],
  ["nn.resolve","Mark as resolved","标记为已解决"],
  ["nn.resolvedOk","Marked as resolved.","已标记为已解决。"],
  ["nn.reopen","Reopen","重新打开"],
  ["nn.reopenHint","Not solved after all? You can reopen it within {n} days.","其实还没解决？{n} 天内可以重新打开。"],
  ["nn.closedNote","This ticket is closed. Send a new ticket if you need more help.","此反馈已关闭。如需更多帮助，请提交新的反馈。"],
  ["nn.rate","How happy are you with our help?","您对我们的处理满意吗？"],
  ["nn.rateStar","{n} of 5","{n} / 5 分"],
  ["nn.rateComment","Comment (optional)","评价（可选）"],
  ["nn.rateSend","Send rating","提交评价"],
  ["nn.rated","Thanks for your rating!","感谢您的评价！"],
  ["nn.yourRating","Your rating: {n} / 5","您的评分：{n} / 5"],
  ["nn.sys.resolved_by_shop","Marked as resolved by the shop","店家已标记为已解决"],
  ["nn.sys.reopened_by_shop","Reopened by the shop","店家重新打开了反馈"],
  ["nn.sys.status","Status changed to {status}","状态已改为：{status}"],
  ["nn.unread","New reply","有新回复"],
  ["nn.by","by {name}","提交人：{name}"],
  ["nn.fromAssistant","via Senvia 助手","来自 Senvia 助手"],
  ["nn.f.all","All","全部"],
  ["nn.f.open","Open","未完成"],
  ["nn.f.done","Resolved / closed","已解决 / 已关闭"],
  ["nn.saLink","Complaints & suggestions","投诉与建议"],
  ["nn.saDone","Sent as ticket {ref}. Follow it under Complaints & suggestions.","已转为反馈 {ref}，可在「投诉与建议」查看进度。"],
  ["nn.saView","View ticket","查看反馈"],
  ["nn.p.title","Complaints & suggestions","投诉与建议"],
  ["nn.p.sub","Tickets from shops. Internal notes are never shown to the shop.","店家提交的反馈。内部备注不会显示给店家。"],
  ["nn.p.tile.open","Open tickets","未结反馈"],
  ["nn.p.tile.awaiting","Awaiting reply","待回复"],
  ["nn.p.tile.frt","Avg first response (30 days)","平均首次回复（30 天）"],
  ["nn.p.tile.unread","Unread","未读"],
  ["nn.p.hours","{n} h","{n} 小时"],
  ["nn.p.search","Search title, shop, e-mail or #number","搜索标题、店家、邮箱或编号"],
  ["nn.p.f.status","Status","状态"],
  ["nn.p.f.unread","Unread","未读"],
  ["nn.p.f.awaiting","Awaiting reply","待回复"],
  ["nn.p.f.from","From","从"],
  ["nn.p.f.to","To","到"],
  ["nn.p.f.clear","Clear filters","清除筛选"],
  ["nn.p.f.shop","Shop","店家"],
  ["nn.p.col.ref","No.","编号"],
  ["nn.p.col.title","Title","标题"],
  ["nn.p.col.updated","Updated","更新时间"],
  ["nn.p.priority","Priority","优先级"],
  ["nn.p.assignee","Assignee","负责人"],
  ["nn.p.unassigned","Unassigned","未分配"],
  ["nn.p.status","Status","状态"],
  ["nn.p.reply","Reply to the shop","回复店家"],
  ["nn.p.note","Internal note","内部备注"],
  ["nn.p.noteHint","Only the Senvia team sees internal notes. Text only.","内部备注只有 Senvia 团队看得到（仅文字）。"],
  ["nn.p.internal","Internal","内部"],
  ["nn.p.send","Send reply","发送回复"],
  ["nn.p.saveNote","Save note","保存备注"],
  ["nn.p.thenStatus","Status after sending","发送后状态"],
  ["nn.p.defaultStatus","Replied (default)","已回复（默认）"],
  ["nn.p.insert","Insert canned reply …","插入常用回复……"],
  ["nn.p.saveCanned","Save as canned reply","存为常用回复"],
  ["nn.p.cannedTitle","Name of the canned reply","常用回复名称"],
  ["nn.p.cannedSaved","Canned reply saved","已保存常用回复"],
  ["nn.p.manageCanned","Canned replies","常用回复"],
  ["nn.p.delete","Delete","删除"],
  ["nn.p.shopLink","Open shop","查看店家"],
  ["nn.p.submitter","Submitted by","提交人"],
  ["nn.p.context","Context","环境信息"],
  ["nn.p.rating","Rating","评分"],
  ["nn.p.saved","Saved","已保存"],
  ["nn.p.shopNone","No tickets from this shop.","此店家没有反馈。"],
  ["nn.p.viewAll","View all","查看全部"],
  ["nn.p.emptyList","No tickets match.","没有符合条件的反馈。"],
  ["nn.p.back","All tickets","全部反馈"],
  ["nn.p.firstResponse","First response: {t}","首次回复：{t}"],
  ["kk.n.ev.feedback","Feedback from a shop (new ticket / new message)","店家投诉与建议（新反馈 / 新消息）"],
  ["ff.mod.feedback","Complaints & suggestions","投诉与建议"],
  ["ff.modHint.feedback","View = read tickets to Senvia; Edit = send tickets and reply. Owner and managers see every ticket, others only their own.","只看 = 查看发给 Senvia 的反馈；可编辑 = 提交反馈和回复。店主和店长看得到全部反馈，其他人只看到自己提交的。"],
  ["apiError.feedback_rate_limited","You sent several tickets in the last hour. Add details to an existing ticket instead.","您在一小时内已提交多条反馈，请在现有反馈里补充说明。"],
  ["apiError.feedback_closed","This ticket is resolved or closed. Reopen it first or send a new ticket.","此反馈已解决或已关闭，请先重新打开或提交新的反馈。"],
  ["apiError.feedback_reopen_expired","Only tickets resolved in the last 14 days can be reopened. Please send a new ticket.","只能重新打开 14 天内解决的反馈，请提交新的反馈。"],
  ["apiError.feedback_not_resolved","You can rate a ticket once it is resolved.","反馈解决后才能评分。"],
] as const;

export type NnKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<NnKey, string>;

export const taskNN = { en: col(1), zh: col(2), ms: col(1) };
